import React, {useState} from 'react';
import * as Icons from 'react-feather';
import {useCore} from "store/core";
import {Loading} from "../form";
import {Link} from "react-router-dom";

export default function Search() {
   const [searchResult, setSearchResult] = useState(false);
   const core = useCore();
   const WAIT_INTERVAL = 1000;
   let timer;

   const handleSearch = (e) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
         core.dispatch(core.getGlobalSearch(e.target.value))
      }, WAIT_INTERVAL);
   }

   const TYPES = {
      Movie: "فیلم",
      Serie: "سریال",
      Music: "موزیک",
      SerieEpisode: "قسمتی از سریال",
      Screening: "اکران",
      Physical: "فیزیکی",
      Download: "دانلودی",
   };

   return (<>
      <div className="intro-x relative ml-3 sm:ml-6">
         <div className="search hidden sm:block">
            <input type="text"
                   onFocus={() => setSearchResult(true)}
                   onBlur={() => setSearchResult(false)}
                   onChange={handleSearch}
                   className="search__input form-control dark:bg-dark-1 border-transparent placeholder-theme-13"
                   placeholder="جستجو..."/>
            <Icons.Search className="search__icon dark:text-gray-300"/>
         </div>
         <a className="notification notification--light sm:hidden" href="">
            <Icons.Search/>
         </a>
         <div className={`search-result ${searchResult ? 'show' : ''}`}>

            <div className="search-result__content">
               {core.globalSearchLoad ? (<Loading/>) : (<>

                  {core.globalSearch && core.globalSearch.users && core.globalSearch.users.length > 0 && <>
                     <div className="search-result__content__title">کاربران</div>
                     <div className="mb-5">
                        {core.globalSearch.users.map(item => (
                           <Link to="/users/users" className="flex items-center mt-2" onClick={() => { 
                              setTimeout(()=>{
                                 window.location.reload()
                              },300)
                              }}>
                              <div className="w-8 h-8 image-fit">
                                 <img alt=""
                                      className="rounded-full"
                                      src={item.avatar || "/images/account.jpg"}/>
                              </div>
                              <div className="mr-3">{item.first_name + ' ' + item.last_name}</div>
                              <div className="mr-auto w-48 truncate text-gray-600 text-xs text-left">
                                 {item.user_name}
                              </div>
                           </Link>
                        ))}
                     </div>
                  </>}

                  {core.globalSearch && core.globalSearch.products && core.globalSearch.products.length > 0 && <>
                     <div className="search-result__content__title">محصولات</div>
                     <div className="mb-5">
                        {core.globalSearch.products.map(item => (
                           <Link to={`products/wizard/${item.id}`} className="flex items-center justify-between mb-1" onClick={() => { 
                              setTimeout(()=>{
                                 window.location.reload()
                              },300)
                              }}>
                              <div className="flex items-center">
                                 <div
                                    className="w-8 h-8 bg-theme-18 text-theme-9 flex items-center justify-center rounded-full">
                                    <Icons.ShoppingBag className="w-4 h-4"/>
                                 </div>
                                 <div className="mr-3">{item.detail.title}</div>
                              </div>
                              <div className="mr-3">{TYPES[item.type]}</div>
                           </Link>
                        ))}
                     </div>
                  </>}

                  {core.globalSearch && core.globalSearch.festivals && core.globalSearch.festivals.length > 0 && <>
                     <div className="search-result__content__title">جشنواره ها</div>
                     <div className="mb-5">
                        {core.globalSearch.festivals.map(item => (
                           <Link to={`/products/festival/${item.id}/${item.title}`} className="flex items-center mb-1" onClick={() => { 
                              setTimeout(()=>{
                                 window.location.reload()
                              },300)
                              }}>
                              <div
                                 className="w-8 h-8 bg-theme-18 text-theme-9 flex items-center justify-center rounded-full">
                                 <Icons.Gift className="w-4 h-4"/>
                              </div>
                              <div className="mr-3">{item.title}</div>
                           </Link>
                        ))}
                     </div>
                  </>}

                  {core.globalSearch && core.globalSearch.packages && core.globalSearch.packages.length > 0 && <>
                     <div className="search-result__content__title">اشتراک ها</div>
                     <div className="mb-5">
                        {core.globalSearch.packages.map(item => (
                           <Link to={`/seals/packages`} className="flex items-center mb-1" onClick={() => { 
                              setTimeout(()=>{
                                 window.location.reload()
                              },300)
                              }}>
                              <div
                                 className="w-8 h-8 bg-theme-18 text-theme-9 flex items-center justify-center rounded-full">
                                 <Icons.Package className="w-4 h-4"/>
                              </div>
                              <div className="mr-3">{item.name}</div>
                           </Link>
                        ))}
                     </div>
                  </>}


               </>)}
            </div>
         </div>
      </div>
   </>);
}